'use strict';

var selectors = {
  dlrsList: '.js-dlrs-list',
  dlrsListContainer: '.js-dlrs-list-container',
  dlrItem: '#jsDlrItem',
  dlrItemClass: '.js-dlr-item',
  dlrsContainer: '.js-dlrs-container',
  dlrName: '.js-dlr-name',
  listMsg: '.js-list-message',
  searchMsg: '.js-search-message',
  formMap: '.js-form-map'
};

var dealerLocator = function () {
  var gmapURL = 'https://maps.googleapis.com/maps/api/js?v=3.exp&sensor=false&libraries=places&language=es-ES&key=AIzaSyDvImGIhJcE8iLYp05B0vYxo6J1hLRS0t4';
  // const gmapURL = 'https://maps.googleapis.com/maps/api/js?v=3.exp&sensor=false&libraries=places&language=es-ES'

  var map = void 0,
      myJson = void 0,
      type = void 0,
      coords = [],
      ids = [],
      infos = [],
      bubbles = [],
      pts = [],
      markers = [],
      images = [],
      imagesOn = [],
      misitems = void 0,
      service = void 0;

  var _init = function _init(params) {
    var showOnlyMainDealers = $(selectors.dlrsContainer).hasClass('js-only-main-dlrs') ? true : false;
    var dealersList = showOnlyMainDealers ? _filterMainDalers(params.data) : params.data;

    $(selectors.dlrsContainer).hasClass('js-only-ventas-dlrs') ? myJson = dealersList.filter(function (item) {
      return item.actividad === "VS - Vtas. y Serv." || item.actividad === "V - Ventas";
    }) : myJson = dealersList;
    type = params.type;
    // Para enseñar en el google maps si el concesionario tiene taller, para pedir "Pide tu cita taller"
    service = params.service;

    var isFormMap = $(selectors.formMap).length > 0;

    myJson.length > 1 || !isFormMap ? $.ajax({
      url: gmapURL,
      dataType: 'script',
      complete: function complete() {
        return _createGMap();
      }
    }) : _concesSelected(dealersList[0].id, dealersList[0].direccion + ' - ' + dealersList[0].poblacion, dealersList[0].cp);
  };

  var _createGMap = function _createGMap() {
    var mapOptions = {
      zoom: 5,
      center: new google.maps.LatLng(40, -3),
      zoomControl: true,
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL,
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      },
      mapTypeControl: false,
      panControl: false
    };

    map = new google.maps.Map(document.getElementById('google-map'), mapOptions);
    _loadDealers(myJson);

    $(selectors.formMap).removeClass('hidden');
  };

  var activityString = function activityString(str) {
    var result = '';
    switch (str) {
      case 'S - Servicio':
        result = 'Servicio';
        break;
      case 'V - Ventas':
        result = 'Ventas';
        break;
      case 'VS - Vtas. y Serv.':
        result = 'Ventas y Servicios';
        break;
      default:
        result = '';
        break;
    }
    return result;
  };

  var _loadDealers = function _loadDealers(myJson) {
    // Reset map variables
    coords = [];
    ids = [];
    infos = [];
    bubbles = [];
    pts = [];
    markers = [];
    images = [];
    imagesOn = [];

    // Filtering items by activity (for SO ad TD we don't put 'S- Servicios' activity hosts and or servicio taller)
    if (service === 1) {
      //misitems = myJson.filter(item => item.actividad !== 'S - Servicio' && item.taller === 1)
      misitems = myJson.filter(function (item) {
        return item.taller === 1;
      });
    } else {
      //misitems = myJson.filter(item => item.actividad !== 'S - Servicio')
      misitems = myJson;
    }

    // Iterates for each plant object received to generate the plants list again

    var _loop = function _loop(i) {
      var num = String(i + 1);
      num = num.length === 1 ? '0' + num : num;
      images[i] = 'marker-off-' + num + '.png';
      imagesOn[i] = 'marker-on-' + num + '.png';

      var curInstalacion = misitems[i];

      ids[i] = curInstalacion.id;
      coords[i] = [Number(curInstalacion.latitud.replace(/,/g, '.')), Number(curInstalacion.longitud.replace(/,/g, '.')), curInstalacion.id];
      infos[i] = '<div class="bubble">\n                  <h4>' + curInstalacion.nombre + '</h4>\n                  <p>' + curInstalacion.direccion + '</p>\n                  <p>' + curInstalacion.cp + ' ' + curInstalacion.poblacion + '</p>\n                </div>';

      if (type === 1) {
        var $it = $(selectors.dlrItem).clone().removeAttr('id').attr('data-id', 'id-' + curInstalacion.id);
        $it.find('.js-it-order').text(String.fromCharCode(65 + i)).on('click', function () {
          return _showMarker('' + curInstalacion.id);
        });
        $it.find('.js-it-name').text(curInstalacion.nombre);
        $it.find('.js-it-address').text(curInstalacion.direccion);
        $it.find('.js-it-postalcode').text(curInstalacion.cp);
        $it.find('.js-it-locality').text(curInstalacion.poblacion);
        $it.find('.js-it-province').text(curInstalacion.provincia);
        $it.find('.js-it-phone').text(curInstalacion.telefono);
        $it.find('.js-it-activity').text(activityString(curInstalacion.actividad));
        $it.find('.js-cita-btn').attr("href", '' + curInstalacion.urlcitataller);
        $it.find('.js-select-btn').on('click', function () {
          _concesSelected(curInstalacion.id, curInstalacion.direccion + ' - ' + curInstalacion.poblacion, curInstalacion.cp);
        });
        $(selectors.dlrsList).append($it);
      }
    };

    for (var i = 0; misitems[i]; i++) {
      _loop(i);
    }
    if (type === 1) {
      $(selectors.dlrsList).slideDown();
    }

    /* if (type === 2){
      let $trigger = $('.js-select-in-map')
      let nId = $trigger.data('id')
      $trigger.on('click', () => _showMarker(`${nId}`))
    } */
    _createPointMarkerInfo();
    _placeMarkers();
    _adjustZoom();
  };

  var _createPointMarkerInfo = function _createPointMarkerInfo() {
    for (var i = 0; coords[i]; i++) {
      pts[i] = new google.maps.LatLng(coords[i][0], coords[i][1]);

      var markerimg = 'https://estatico.nissan.es/commons/gmap-markers/' + images[i];
      var markerimgOn = 'https://estatico.nissan.es/commons/gmap-markers/' + imagesOn[i];

      markers[i] = new google.maps.Marker({ position: pts[i], icon: markerimg, iconOff: markerimg, iconOn: markerimgOn, code: coords[i][2] });

      bubbles[i] = new google.maps.InfoWindow({ maxHeight: 320 });
      bubbles[i].setContent(infos[i]);
      bubbles[i].setPosition(pts[i]);
    }
  };

  var _placeMarkers = function _placeMarkers() {
    for (var k = 0; markers[k]; k++) {
      markers[k].setMap(map);
      bubbles[k].close(map);
      google.maps.event.addListener(markers[k], 'click', function () {
        var n = $.inArray(this, markers);
        for (var i = 0; markers[i]; i++) {
          markers[i].setIcon(markers[i].iconOff);
          if (i != n) {
            bubbles[i].close(map);
          }
        }
        this.setIcon(this.iconOn);
        this.setZIndex(google.maps.Marker.MAX_ZINDEX + 1);
        bubbles[n].open(map, this);
        $('.bubble').parent().css('overflow', ''); //Solution for scroll infowindow bug
        // Mark item in list
        var myid = ids[n];
        var todositems = $(selectors.dlrItemClass);
        var item = $('*[data-id=id-' + myid + ']');
        if (!item.hasClass('redselected')) {
          todositems.removeClass('redselected');
          item.addClass('redselected');
        }
        // !!! Requires jquery.scrollTo.js plugin!
        if (type === 1) {
          $(selectors.dlrsList).scrollTo(item);
          $(selectors.dlrsListContainer).scrollTo(item);
        }

        if (type === 2) {
          item.trigger('click');
          //let top = item.offset().top
          //$('body, html').scrollTop(top)
        }
      });
    }
  };

  var _adjustZoom = function _adjustZoom() {
    if (map) {
      if (pts.length > 1) {
        var bounds = new google.maps.LatLngBounds();
        for (var i = 0; i < pts.length; i++) {
          bounds.extend(pts[i]);
        }
        map.fitBounds(bounds);
      } else {
        map.setCenter(pts[0]);
        map.setZoom(13);
      }
    }
  };

  var _showMarker = function _showMarker(id) {
    var todositems = $(selectors.dlrItemClass);
    var item = $('#li-' + id);
    if (!item.hasClass('redselected')) {
      todositems.removeClass('redselected');
      item.addClass('redselected');
    }
    for (var i = 0; i < markers.length; i++) {
      var curMarker = markers[i];
      if (curMarker.code == id) {
        curMarker.setIcon('https://estatico.nissan.es/commons/gmap-markers/' + imagesOn[i]);
        bubbles[i].open(map, curMarker);
        var myPoint = new google.maps.LatLng(curMarker.position.lat(), curMarker.position.lng());
        map.panTo(myPoint);
        map.setZoom(12);
      } else {
        bubbles[i].close(map);
        curMarker.setIcon('https://estatico.nissan.es/commons/gmap-markers/' + images[i]);
        $('#check-' + curMarker.code).removeAttr('checked');
      }
    }
  };

  var _concesSelected = function _concesSelected(concesion, hostAddress, cp) {
    controlHostValue.setSelection(concesion, hostAddress, cp);
  };

  var _filterMainDalers = function _filterMainDalers(dealers) {
    return dealers.filter(function (dealer) {
      return dealer.id === dealer.idPrincipal;
    });
  };

  return {
    init: _init,
    showMarker: _showMarker,
    concesSelected: _concesSelected
  };
}();

var controlHostValue = function () {
  var txtConcesion = void 0,
      txtModificar = void 0;

  var _init = function _init(txtConc, txtModif) {
    txtConcesion = txtConc;
    txtModificar = txtModif;
  };

  // ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  function _getTxtConc() {
    return txtConcesion;
  }

  function _getTxtModif() {
    return txtModificar;
  }

  function _setSelection(concesion, hostAddress, cp) {
    $('#pvCodhost').val(concesion);
    // Adding value to VVS forms
    $('.js-field-dealer').val(concesion);
    $(selectors.dlrName).html(_getTxtConc() + ' ' + '<strong>' + hostAddress + '</strong> ');
    var botonModificar = $('<button/>').text(_getTxtModif).addClass('h-btn grey h-icon editpencil2').on('click', function (event) {
      event.preventDefault();
      _abreConces();
    });
    $(selectors.dlrName).append(botonModificar);
    $(selectors.dlrsContainer).slideUp();
  }

  function _abreConces() {
    $(selectors.dlrName).text($(selectors.dlrName).attr('data-defecto'));
    $(selectors.dlrsContainer).slideDown('slow');
  }

  return {
    init: _init,
    setSelection: _setSelection
  };
}();